import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { GoogleLoginService } from 'src/app/admin/google-login/google-login.service';
import { AppService } from './../Services/app.service';
import jwt_decode from "jwt-decode";

@Injectable({
  providedIn: 'root'
})

export class RouteGuardService implements CanActivate {

  user: any;
  decoded: any;
  currentTime: any;

  constructor(
    private router: Router,
    private appService: AppService,
    private googleLoginService: GoogleLoginService
  ) { }

  public canActivate(route: ActivatedRouteSnapshot): any {
    let user = sessionStorage.getItem('token');
    if (user) {
      this.decoded = jwt_decode(user);
      this.currentTime = Math.floor(new Date().valueOf() / 1000)
      if (this.decoded.exp < this.currentTime) {
        this.googleLoginService.logout({ token: user }).subscribe((result: any) => {
          this.router.navigate(['/login']);
        }, (err: any) => {
          this.router.navigate(['/login']);
          console.log(err, "error");
        })
      }
      this.appService.validateUser().subscribe((result: any) => {
      }, (err: any) => {
        console.log(err);
      })
      return new Observable((observer: any) => {
        observer.next(true);
        return;
      })
    }
    else {
      this.router.navigate(['/login']);
      return false;
    }
  }
}
